import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container sx={{ textAlign: 'center', mt: 10 }}>
      <Box>
        <Typography variant='h1' color='error' gutterBottom>
          404
        </Typography>
        <Typography variant='h5' gutterBottom>
          Oops! The page you&apos;re looking for doesn&apos;t exist.
        </Typography>
        <Button
          variant='contained'
          color='primary'
          onClick={() => navigate('/')}
        >
          Go Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
